import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
console.log("BACKEND_URL =", BACKEND_URL);
export const API = `${BACKEND_URL}/api`;


export const submitInquiry = async (payload) => {
  console.log("API URL:", `${API}/inquiries`);
  console.log("Payload:", payload);
  const res = await axios.post(`${API}/inquiries`, payload, {
    headers: { "Content-Type": "application/json" },
  });
  console.log("Response:", res);
  return res.data;
};
